export default __webpack_public_path__ + "static/media/voc.26538642.svg";